/**
 * System-wide constants related to IEPs and 504 plans.
 */
const PLAN_TYPE_IEP = 'iep'
const PLAN_TYPE_IPP = 'ipp'
const PLAN_TYPE_504 = '504'

const PLAN_TYPES = [PLAN_TYPE_IEP, PLAN_TYPE_IPP, PLAN_TYPE_504]

const PLAN_TYPE_ROUTE_ROOTS = {
  [PLAN_TYPE_IEP]: 'ieps',
  [PLAN_TYPE_IPP]: 'ipps',
  [PLAN_TYPE_504]: '504s'
}

const GOAL_TYPE_PRIMARY = 'primary'
const GOAL_TYPE_SECONDARY = 'secondary'

const ACCOMMODATION_TYPE_ACCOMMODATION = 'accommodation'
const ACCOMMODATION_TYPE_MODIFICATION = 'modification'

const RECOMMENDATION_STATUS_OPEN = 'open'
const RECOMMENDATION_STATUS_RESOLVED = 'promoted'
const RECOMMENDATION_STATUS_DISMISSED = 'dismissed'

const REVIEW_STATUS_REVIEWED = 'reviewed'
const REVIEW_STATUS_NOT_REVIEWED = 'notReviewed'

const CONCERN_STATUS_OPEN = 'open'
const CONCERN_STATUS_RESOLVED = 'resolved'
const CONCERN_STATUS_DELETED = 'deleted'

const FEATURE_IEP_REVIEW = 'UND-5878'

export {
  PLAN_TYPE_IEP,
  PLAN_TYPE_IPP,
  PLAN_TYPE_504,
  PLAN_TYPES,
  PLAN_TYPE_ROUTE_ROOTS,
  GOAL_TYPE_PRIMARY,
  GOAL_TYPE_SECONDARY,
  ACCOMMODATION_TYPE_ACCOMMODATION,
  ACCOMMODATION_TYPE_MODIFICATION,
  RECOMMENDATION_STATUS_OPEN,
  RECOMMENDATION_STATUS_RESOLVED,
  RECOMMENDATION_STATUS_DISMISSED,
  REVIEW_STATUS_REVIEWED,
  REVIEW_STATUS_NOT_REVIEWED,
  CONCERN_STATUS_OPEN,
  CONCERN_STATUS_RESOLVED,
  CONCERN_STATUS_DELETED,
  FEATURE_IEP_REVIEW
}
